<template>
  <nav class="cc-ui-navigation-footer">
    <cognitive-list>
      <cognitive-list-item inline>
        <Logo class="cc-ui-navigation-footer__logo" />
      </cognitive-list-item>
      <cognitive-list-item
        v-for="(header, index) in footerHeaders"
        :key="`header-${index}`"
        inline
        class="cc-ui-navigation-footer__menu">
        <template v-if="header.path && !header.external">
          <router-link :to="header.path">
            <cognitive-paragraph>{{ header.name }}</cognitive-paragraph>
          </router-link>
        </template>
        <template v-else-if="header.path && header.external">
          <a :href="header.path" target="_blank" rel="noopener noreferrer">
            <cognitive-paragraph>{{ header.name }}</cognitive-paragraph>
          </a>
        </template>
        <template v-else>
          <cognitive-button version="link" @click="header.action">
            {{ header.name }}
          </cognitive-button>
        </template>
      </cognitive-list-item>
    </cognitive-list>
    <cognitive-modal name="privacy" cta-dismiss-only>
      <PrivacyPolicy />
    </cognitive-modal>
    <cognitive-paragraph class="cc-ui-navigation-footer__copy" padding="sm" size="xs">
      Cognitive Credit&trade; | Copyright &copy; {{ new Date().getFullYear() }} All rights reserved.
      <br />
      <br />
      Cognitive Credit Ltd. | 1 Hudsons Place | London SW1V 1JT
    </cognitive-paragraph>
  </nav>
</template>

<script>
// Libs
import { defineAsyncComponent } from 'vue'
// Store
import { mapActions } from 'vuex'

// Components Async
const PrivacyPolicy = defineAsyncComponent(() => import('@/components/common/PrivacyPolicy/PrivacyPolicy.vue'))

const Logo = defineAsyncComponent(() => import('@/assets/images/cognitive-credit-compressed.svg'))
export default {
  name: 'MainFooter',
  components: {
    PrivacyPolicy,
    Logo,
  },
  data() {
    return {
      footerHeaders: [
        {
          name: 'Homepage',
          path: 'https://www.cognitivecredit.com',
          external: true,
        },
        {
          name: 'Support',
          action: this.openSupport,
        },
        {
          name: 'Privacy Policy',
          action: this.showPrivacyPolicy,
        },
      ],
    }
  },
  methods: {
    ...mapActions('Modal', ['openModal']),
    openSupport() {
      this.openModal({ name: 'contactUsModal' })
    },
    showPrivacyPolicy() {
      this.openModal({ name: 'privacy' })
    },
  },
}
</script>

<style lang="scss">
// Custom Vars
$login-footer-h: 3.5rem;

.cc-ui-navigation-footer {
  background: $black-pearl;
  flex: 0 1 auto;
  flex-direction: column;
  flex-wrap: nowrap;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
  flex-direction: row;
  align-items: center;
  min-height: $login-footer-h;
  padding: $sp-sm;

  &__logo {
    height: $sp-lg;
    width: auto;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    fill: $baby-powder;
  }

  &__menu {
    .cc-ui-paragraph {
      color: $baby-powder;
      padding: $sp-sm;
      font-size: $fs-xs;

      &:first-of-type {
        padding-left: $sp-md;
      }
    }

    .cc-ui-button {
      color: $baby-powder;
      margin-right: $sp-sm;
    }
  }

  &__copy {
    &.cc-ui-paragraph {
      padding: $sp-lg 0 $sp-xs;
      color: $baby-powder;
      text-align: left;
      line-height: 0.75rem;

      @media #{$mq-md} {
        padding: 0 $sp-sm;
        text-align: right;
      }
    }
  }
}
</style>
